import { FC } from 'react';
import { MRVideo } from '../video/VideoCard';

interface Props {
  props: {
    disabled: boolean;
    cardType: string;
    sectionPadding: boolean;
  };
  className?: string;
  children?: React.ReactNode;
}

export const StaticVideoCards: FC<Props> = (
  { props: { disabled, cardType, sectionPadding } },
  className
) => {
  const cardTypes: Record<string, JSX.Element> = {
    'quick-connect': (
      <MRVideo
        variantButton='blue'
        play={true}
        loop={true}
        id='feature-video'
        url={
          'https://res.cloudinary.com/dbkbadq4w/video/upload/f_auto:video,q_auto/mc_quick_connect_lineset'
        }
        size='lg'
        allowUnmute={false}
        autoPlayOnView={true}
      />
    ),
    gen5: (
      <MRVideo
        variantButton='blue'
        play={true}
        loop={true}
        id='feature-video'
        url={
          'https://res.cloudinary.com/dbkbadq4w/video/upload/f_auto:video,q_auto/web/mrcool.com/5th%20Gen%20DIY/Video%20clips/MRCOOL_DIY_5th_GenDisplay_gy0szy'
        }
        size='lg'
        allowUnmute={true}
        autoPlayOnView={true}
      />
    ),
  };

  if (disabled) return null;

  return cardTypes[cardType] || null;
};
